// extracted by mini-css-extract-plugin
export var expandIcon = "fB_vR";
export var rotated = "fB_vS";